import 'jquery-ui/themes/base/core.css'
import 'jquery-ui/themes/base/menu.css'
import 'jquery-ui/themes/base/autocomplete.css'
import 'jquery-ui/themes/base/theme.css'
import 'jquery-ui/ui/widgets/autocomplete'

$(function () {
  var jobFormWrapper = $("#jobFormWrapper, #businessFormWrapper");

  jobFormWrapper.each(function () {
    var $wrapper = $(this);
    var $input = $wrapper.find("#job_suburb_name, #business_suburb_name");
    var $hiddenField = $wrapper.find("#job_suburb_id, #business_suburb_id");

    $input.autocomplete({
      source: function (request, response) {
        $.getJSON("/suburbs", { query: request.term, format: "json" }, function (data) {
          response(data.map(function (item) {
            return {
              label: item.name,
              value: item.name,
              id: item.id
            };
          }));
        });
      },
      minLength: 3,
      select: function (event, ui) {
        $input.val(ui.item.value);
        $hiddenField.val(ui.item.id).trigger("change");
        return false;
      }
    });

    window.triggerAutocomplete = function (value) {
      $input.val(value);
      $input.autocomplete("search", value);
    };
  });
});
